import { UserCompanyInfo } from "src/app/ui/models/domains/pbm/user/user-company-info";

export class UserCompanyInfoFactory {
  static createUserCompanyInfo(payload: any): UserCompanyInfo {
    const userCompanyInfo = new UserCompanyInfo();
    if (payload) {
      userCompanyInfo.setTelephone(payload.Telephone != undefined ? payload.Telephone : payload.telephone);
      userCompanyInfo.setFiscalNumber(payload.FiscalNumber != undefined ? payload.FiscalNumber : payload.fiscalNumber);
      userCompanyInfo.setCorporateName(payload.CorporateName != undefined ? payload.CorporateName : payload.corporateName);
      userCompanyInfo.setHealthProfessional(payload.HealthProfessional != undefined ? payload.HealthProfessional : payload.healthProfessional);
      userCompanyInfo.setClassCouncil(payload.ClassCouncil != undefined ? payload.ClassCouncil : payload.classCouncil);
      userCompanyInfo.setRegistrationNumber(payload.RegistrationNumber != undefined ? payload.RegistrationNumber : payload.registrationNumber);
    }
    return userCompanyInfo;
  }
}
